import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_AddressForm = _resolveComponent("AddressForm");
  const _component_CreditCardForm = _resolveComponent("CreditCardForm");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  return _openBlock(), _createBlock(_component_b_card, null, {
    default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
      default: _withCtx(() => [!$props.isRegistration ? (_openBlock(), _createBlock(_component_b_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_form_group, {
            label: "Nickname"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_form_input, {
              type: "text",
              modelValue: _ctx.form.billing.nickname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.billing.nickname = $event),
              modelModifiers: {
                lazy: true
              },
              placeholder: "Card Nickname"
            }, null, 8, ["modelValue"])], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("label", {
              class: "control-label"
            }, "Name on card *", -1)), _createVNode(_component_b_form_input, {
              type: "text",
              modelValue: _ctx.form.billing.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.billing.name = $event),
              modelModifiers: {
                lazy: true
              },
              disabled: _ctx.loading,
              placeholder: "Name on card",
              state: $options.getFormState('name'),
              onBlur: _cache[2] || (_cache[2] = $event => _ctx.$v.form.billing.name.$touch()),
              autocomplete: "cc-name"
            }, null, 8, ["modelValue", "disabled", "state"])], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        }), !$props.billingrecord ? (_openBlock(), _createBlock(_component_b_col, {
          key: 0,
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_form_group, null, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("label", {
              class: "control-label"
            }, "Billing Address", -1)), _createVNode(_component_b_input_group, null, {
              default: _withCtx(() => [_createVNode(_component_b_form_checkbox, {
                modelValue: _ctx.form.billingAddressSame,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.form.billingAddressSame = $event)
              }, null, 8, ["modelValue"]), _createVNode(_component_b_input_group_append, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Billing address is the same as main address ", -1)]))], undefined, true),
                _: 1
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          })], undefined, true),
          _: 1
        })) : _createCommentVNode("", true)], undefined, true),
        _: 1
      }), !_ctx.form.billingAddressSame || !$props.isRegistration ? (_openBlock(), _createBlock(_component_b_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12"
        }, {
          default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)), _createVNode(_component_AddressForm, {
            countries: $props.countries,
            states: $props.states,
            disabled: _ctx.form.billingAddressSame,
            mainaddress: $props.address,
            onDataChange: $options.setAddress,
            "is-registration": $props.isRegistration
          }, null, 8, ["countries", "states", "disabled", "mainaddress", "onDataChange", "is-registration"])], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, {
          cols: "12",
          class: "text-center"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("hr", {
            class: "mb-5"
          }, null, -1), _createElementVNode("span", {
            class: "text-danger",
            style: {
              "font-size": "1.1rem"
            }
          }, [_createElementVNode("b", null, "Please note: This charge will appear on your statement from \"SBN Musical Performances Online\".")], -1), _createElementVNode("hr", {
            class: "mt-5"
          }, null, -1)]))], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_CreditCardForm, {
        billing: $props.billingrecord,
        onUpdate: $options.setCard,
        "is-registration": $props.isRegistration
      }, null, 8, ["billing", "onUpdate", "is-registration"])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  });
}